import { IMyLeadInitialState } from "../../../types/sales/myLeadInterface";
import { LeadActionTypes, LeadActions } from "../../actionTypes/sales/leadActionTypes";

const initialState: IMyLeadInitialState = {
  myLeadList: [],
  myLeadData: {
    id: 0,
    lead_code: "",
    status: "",
    source: "",
    industry: "",
    contact_person: "",
    contact_person_designation: "",
    tags: [],
    email: "",
    address: "",
    pincode: 0,
    website: "",
    contact_number: "",
    alternate_contact_number: "",
    company_name: "",
    customer_business_potential: 0,
    tqs_wallet_share: 0,
    turnover: 0,
    description: "",
    competitor: "",
    billing_cycle: "",
    director_name: "",
    director_contact_number: "",
    director_email: "",
    referred_by: 0,
    assigned_to: 0,
    created_by: 0,
    pincode_data: {
      id: 0,
      pincode: 0,
      district: {
        district_name: "",
        state: {
          state_name: "",
        },
      },
    },
    users: {
      name: "",
    },
  },
  myLeadListPageCount: 0,
};

export default function myLeadReducer(state = initialState, action: LeadActionTypes): IMyLeadInitialState {
  switch (action.type) {
    case LeadActions.SET_MY_LEAD_LIST:
      return {
        ...state,
        myLeadList: action.payload,
      };

    case LeadActions.SET_MY_LEAD_LIST_PAGE_COUNT:
      return {
        ...state,
        myLeadListPageCount: action.payload,
      };

    case LeadActions.GET_MY_LEAD_DATA_BY_ID:
      return {
        ...state,
        myLeadData: action.payload
      }

    default:
      return state;
  }
}
